import * as sober from '../dist/main.js'
globalThis.sober = sober